import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { ProductKeyList } from "src/config/config";

// OCI로 생성된 사이트인지 파악
export const useIsOciProduct = () => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  // console.log(
  //   "ProductKeyList.includes(userInfo?.loginType)",
  //   ProductKeyList.includes(userInfo?.loginType),
  //   userInfo?.loginType
  // );
  return { isOciProduct: ProductKeyList.includes(userInfo?.loginType) };
  // return { isOciProduct: true };
};
